import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import successImg from "../../assets/images/Others/order-success.png";
import { useQueryClient } from "@tanstack/react-query";

const SuccessModal = ({ show, onHide, successData }) => {
  const queryClient = useQueryClient();

  const handleNavigation = () => {
    queryClient.invalidateQueries({
      queryKey: ["cartItemCount"],
      exact: false,
    });
    queryClient.invalidateQueries({
      queryKey: ["cartData"],
      exact: false,
    });
    onHide();
  };

  const onCloseModal = () => {
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onCloseModal}
      className="product-quickview-modal-wrapper product_card_modal"
      backdrop="static"
    >
      <Modal.Body>
        <section className="order_success_page">
          <img src={successImg} alt="Order success" className="success_img" />
          {/* <h6>Success</h6> */}
          <p>
            Order placed successfully. Kindly check your order book to view
            status
          </p>
          <div className="order_success_data">
            <p>
              <span>Your Order #</span> <span>{successData.OrderNo}</span>
            </p>
          </div>
          <div className="success_btn_con">
            <Link
              className="button primary_btn"
              to={`/order/${successData.OrderId}`}
              onClick={handleNavigation}
            >
              View Order
            </Link>
            <Link
              to="/"
              className="button primary_btn"
              onClick={handleNavigation}
            >
              Continue to Site
            </Link>
          </div>
        </section>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessModal;
